<div class="platform-settings-page">
    <h2>Platform Settings</h2>

    <p-progressSpinner *ngIf="isLoading" styleClass="page-spinner"></p-progressSpinner>

    <ng-container *ngIf="!isLoading">
        <p-card header="Premium / Royal Activation Alerts" styleClass="settings-card">
            <div class="field-row">
                <label for="activationAlertsEnabled">Activation alerts enabled</label>
                <p-inputSwitch inputId="activationAlertsEnabled" [(ngModel)]="activationAlertsEnabled"></p-inputSwitch>
            </div>
            <div class="field-column">
                <label for="premiumRecipients">Premium activation recipients (one email per line)</label>
                <textarea id="premiumRecipients" pInputTextarea rows="4" [(ngModel)]="premiumRecipientsText"
                    placeholder="ops@example.com"></textarea>
            </div>
            <div class="field-column">
                <label for="royalRecipients">Royal activation recipients (one email per line)</label>
                <textarea id="royalRecipients" pInputTextarea rows="4" [(ngModel)]="royalRecipientsText"
                    placeholder="ops@example.com"></textarea>
            </div>
        </p-card>

        <p-card header="Daily Platform Digest" styleClass="settings-card">
            <div class="field-row">
                <label for="digestEnabled">Daily digest enabled</label>
                <p-inputSwitch inputId="digestEnabled" [(ngModel)]="digestEnabled"></p-inputSwitch>
            </div>
            <div class="field-column">
                <label for="digestRecipients">Digest recipients (one email per line)</label>
                <textarea id="digestRecipients" pInputTextarea rows="4" [(ngModel)]="digestRecipientsText"
                    placeholder="ops@example.com"></textarea>
            </div>
            <div class="field-row">
                <label for="digestAiSummaryEnabled">AI summary section (optional, guarded)</label>
                <p-inputSwitch inputId="digestAiSummaryEnabled" [(ngModel)]="digestAiSummaryEnabled"></p-inputSwitch>
            </div>
            <div class="actions-row">
                <button pButton type="button" label="Preview digest" icon="pi pi-eye" class="p-button-outlined"
                    [loading]="isDigestActionRunning" (click)="previewDigest()"></button>
                <button pButton type="button" label="Send test digest" icon="pi pi-send" class="p-button-outlined"
                    [loading]="isDigestActionRunning" (click)="confirmSendTestDigest()"></button>
            </div>
        </p-card>

        <div class="actions-row">
            <button pButton type="button" label="Save settings" icon="pi pi-save"
                [loading]="isSaving" (click)="save()"></button>
        </div>
    </ng-container>
</div>

<p-dialog header="Digest Preview" [(visible)]="isPreviewOpen" [modal]="true" [style]="{width: '40rem'}">
    <ng-container *ngIf="digestPreview">
        <p class="preview-range">{{ digestPreview.from | date:'medium' }} → {{ digestPreview.to | date:'medium' }}</p>
        <ul class="preview-list">
            <li><b>New users:</b> {{ digestPreview.newUsers }}</li>
            <li><b>New Premium activations:</b> {{ digestPreview.newPremiumActivations }}</li>
            <li><b>New Royal activations:</b> {{ digestPreview.newRoyalActivations }}</li>
            <li><b>Total orders:</b> {{ digestPreview.totalOrders }}</li>
            <li><b>Active sessions:</b> {{ digestPreview.activeSessions }}</li>
        </ul>
        <h4 *ngIf="digestPreview.ordersByType">Orders by type</h4>
        <ul class="preview-list">
            <li *ngFor="let entry of digestPreview.ordersByType | keyvalue">{{ entry.key }}: {{ entry.value }}</li>
        </ul>
        <h4 *ngIf="digestPreview.newHubs?.length">New hubs</h4>
        <ul class="preview-list">
            <li *ngFor="let hub of digestPreview.newHubs">{{ hub.name }} ({{ hub.urlHandler }})</li>
        </ul>
        <h4 *ngIf="digestPreview.topHubs?.length">Top hubs</h4>
        <ul class="preview-list">
            <li *ngFor="let hub of digestPreview.topHubs">{{ hub.name }} — {{ hub.orders }} orders</li>
        </ul>
        <h4 *ngIf="digestPreview.outliers?.length">Outliers</h4>
        <ul class="preview-list">
            <li *ngFor="let outlier of digestPreview.outliers">{{ outlier }}</li>
        </ul>
    </ng-container>
</p-dialog>
